import {
  MynauiEditOne,
  TablerCaretUpDownFilled,
} from "../../assets/icons/icons";
import useSortableData from "../../utils/SortData";
import EmptyTableRecord from "../layout/EmptyTableRecord";
import { formatDateParts } from "../../utils/DateFormat";
import { useSession } from "../layout/SessionContext";

const TABLE_HEADERS = [
  //   { key: "createdAt", label: "Date added" },
  { key: "retailerId", label: "Retailer ID" },
  { key: "retailerName", label: "Retailer name" },
  { key: "retailerEmail", label: "Email address" },
  { key: "code", label: "Referral code" },
  { key: "totalCustomers", label: "No of customers" },
  { key: "totalSales", label: " Total sales" },
  { key: "action", label: "Action", isAction: true },
];

const PromoCodeTable = ({ promoCode, setPromoCode, onEditClick, selectedColumns }) => {
  const { hasPermission } = useSession();
  const { sortedItems: sortedPromoCode, handleSort } =
    useSortableData(promoCode);
  const handleEditPromoCode = (bannerId) => {
    const BannerToEdit = promoCode.find((b) => b._id === bannerId);
    if (!BannerToEdit) return;

    const updatedBanner = {
      ...BannerToEdit,
      product: {
        ...BannerToEdit.product,
        _id:
          BannerToEdit?.product?._id == null &&
          BannerToEdit?.product?.name === "INTERNATIONAL"
            ? "INTERNATIONAL"
            : BannerToEdit.product?._id,
      },
    };
    onEditClick(updatedBanner);
  };
  const getNestedValue = (obj, path) => {
    if (!obj || !path) return "N/A";

    const keys = path.split(".");

    if (
      path === "product.name" &&
      typeof obj.product === "object" &&
      !Array.isArray(obj.product) &&
      obj.product?.name === "INTERNATIONAL"
    ) {
      return "International";
    }
    if (path === "product.name" && Array.isArray(obj.product)) {
      return obj.product[0]?.name || "";
    }

    return keys.reduce((acc, key) => {
      return acc && acc[key] !== undefined ? acc[key] : "";
    }, obj);
  };
  // Only show selected columns
  const visibleHeaders = TABLE_HEADERS.filter(h => selectedColumns?.includes(h.key));
  return (
    <div className="rounded-lg border-t border-x border-b border-gray-300 overflow-x-auto mb-6">
      {/* Desktop/tablet view */}
      <div className="hidden sm:block">
        <table className="w-full border-gray-300 rounded-md">
          <thead className="bg-gray-100 border-b rounded-md relative">
            <tr className="md:h-10">
              {visibleHeaders.map((header, index) => {
                if (header.key === "action" && !hasPermission("Referral Code", "edit")) {
                  return null;
                }
                return (
                  <th
                    key={index}
                    className="px-2 py-3 text-center font-semibold text-[15px] text-text1 whitespace-nowrap max-w-96 md:h-10"
                  >
                    {header.key !== "action" ? (
                      <div
                        className="flex items-center cursor-pointer justify-start"
                        onClick={() => handleSort(header.key)}
                      >
                        <TablerCaretUpDownFilled className="mr-2" />
                        {header.label}
                      </div>
                    ) : (
                      <div className="flex justify-start items-center">
                        {header.label}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {sortedPromoCode.length > 0 ? (
              sortedPromoCode.map((promoCode) => (
                <tr key={promoCode._id} className="md:h-[60px]">
                  {visibleHeaders.map((header) => {
                    if (header.key === "action" && !hasPermission("Referral Code", "edit")) {
                      return null;
                    }
                    return (
                      <td
                        key={header.key}
                        className="py-4 pl-2 text-[15px] font-normal text-[#374151] text-left md:h-[60px] max-w-96"
                      >
                        {header.key === "createdAt" ? (
                          <span className="whitespace-nowrap">
                            {(() => {
                              const { date, time } = formatDateParts(promoCode[header.key]);
                              return (
                                <>
                                  <div>{date}</div>
                                  <div>{time}</div>
                                </>
                              );
                            })()}
                          </span>
                        ) : header.isAction ? (
                          <div className="flex justify-start items-center">
                            <button
                              onClick={() => handleEditPromoCode(promoCode._id)}
                              className="px-2 rounded"
                            >
                              <MynauiEditOne className="text-gray-400" />
                            </button>
                          </div>
                        ) : header.key === "product.name" ? (
                          Array.isArray(promoCode.product) ? (
                            promoCode.product[0]?.name || "N/A"
                          ) : (
                            getNestedValue(promoCode, header.key)
                          )
                        ) : header.key === "totalSales" ? (
                          promoCode.totalSales.toFixed(2) || 0
                        ) : (
                          getNestedValue(promoCode, header.key)
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={visibleHeaders.length}
                  className="text-center text-gray-500"
                >
                  <EmptyTableRecord />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Mobile view */}
      <div className="block md:hidden">
        {sortedPromoCode.length > 0 ? (
          sortedPromoCode.map((promoCode) => (
            <table key={promoCode._id} className="w-full border border-gray-200 rounded-none bg-white shadow-sm">
              <tbody>
                {visibleHeaders.map(header => {
                  if (header.key === "action" && !hasPermission("Referral Code", "edit")) {
                    return null;
                  }
                  return (
                    <tr key={header.key}>
                      <td className="py-2 px-2 text-[16px] font-medium  text-gray-900 w-1/2 align-top">{header.label}</td>
                      <td className="py-2 px-2 text-[16px] font-normal  text-gray-700 w-1/2 align-top break-words max-w-[140px] overflow-hidden text-ellipsis">
                        {header.key === "totalSales" ? (
                          promoCode.totalSales.toFixed(2) || 0
                        ) : header.key === "action" ? (
                          <button
                            onClick={() => handleEditPromoCode(promoCode._id)}
                            className="px-2 py-1 rounded bg-gray-100 text-gray-700 text-xs flex items-center justify-end"
                          >
                            <MynauiEditOne className="text-gray-400 mr-1" />
                          </button>
                        ) : (
                          promoCode[header.key] || "N/A"
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ))
        ) : (
          <EmptyTableRecord />
        )}
      </div>
    </div>
  );
};

export default PromoCodeTable;
